import { render, staticRenderFns } from "./MediaReferenceList.vue?vue&type=template&id=7283588c&scoped=true&"
import script from "./MediaReferenceList.vue?vue&type=script&lang=js&"
export * from "./MediaReferenceList.vue?vue&type=script&lang=js&"
import style0 from "./MediaReferenceList.vue?vue&type=style&index=0&id=7283588c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7283588c",
  null
  
)

export default component.exports